import { CiSearch } from "react-icons/ci";

export const SearchIcon = ({ style, ...rest }) => {
  return <CiSearch style={{ fontSize: "25px", ...style }} {...rest} />;
};
